
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components"
import { useSelector } from "react-redux";
import { setDevamliAraclarValues } from "../../../features/joblist/jobListSlice";
import { handleActiveSelect } from "../../../features/layout/layoutSlice";

const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;
    /* margin: 0 auto; */

    input{
      width: 100%;
        height: 100%;
        padding: 10px 20px;
        padding-right: 30px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-color: ${({isActive, theme}) => isActive && theme.mainTextColor};
        border-radius: ${({radius}) => radius};
        border-bottom-left-radius: ${({isActive}) => isActive && 0};
        border-bottom-right-radius: ${({isActive}) => isActive && 0};
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
        color: ${({showErrors}) => showErrors && "var(--color-red)"};

    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
        color: ${({showErrors}) => showErrors && "var(--color-red)"};
    }

    .result{
      position: absolute;
        top: 40px;
        background-color: ${({theme}) => theme.mainBgColor};
        display: flex;
        flex-direction: column;
        z-index: 10;
        width: 100%;
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-color: ${({isActive, theme}) => isActive && theme.mainTextColor};
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        max-height: 300px;
        overflow: auto;
        p{
            padding: 5px;
            font-size: 12px;
            font-weight: var(--font-weight-lg);
            cursor: pointer;
        }
    }
`

const KasaTipiInput = ({data, keyData, name, labelText, options, inputWidth}) => {
    const {activeSelect} = useSelector(state => state.layout)
    const [text, setText] = useState(data);
    const [filtered, setFiltered] = useState([])
    const {kasaTypeOptions} = useSelector((state) => state.jobList)

    const dispatch = useDispatch()

    useEffect(() => {
        setText(data);
    }, [data]);

    useEffect(() => {
        setFiltered(kasaTypeOptions.kasaTypeOptions);
    }, [kasaTypeOptions.kasaTypeOptions]);

    const handleSearch = (event) => {
        const term = event.target.value?.toLowerCase();
        dispatch(setDevamliAraclarValues({ keyData, value: term}) );

        const filteredDatas = kasaTypeOptions.kasaTypeOptions.filter((search) =>
            search.name?.toLowerCase()?.includes(term)
        );

        setFiltered(filteredDatas)
    };

    const handleSelect = (value) => {
        dispatch(setDevamliAraclarValues({ keyData, value: value}) );
        dispatch(handleActiveSelect(null))
    };


  return (
    <Container isActive={activeSelect === name} value={data} radius={"5px"} inputWidth={inputWidth}>
        <input onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === name) ? null : name))} type="text" id={"text"} onChange={handleSearch} value={data?.name || data || ""} name={name}/> 
        <label htmlFor={"text"}>{labelText}</label>

        {activeSelect === name && (
        <div className="result">
          {filtered?.map((item) => (
            <p onClick={() => handleSelect(item)}>{item.name}</p>
          ))}
        </div>
      )}
    </Container>
  )
}

export default KasaTipiInput